import { Box } from '@mui/material'

import type { ArticleState } from '../types/article.types'

const STATUS_STYLES = {
  draft: { bg: '#fff7e6', border: '#efd9a7', color: '#b7791f' },
  review: { bg: '#eef2ff', border: '#d5d9eb', color: '#344054' },
  approved: { bg: '#e0f2fe', border: '#bae6fd', color: '#0369a1' },
  published: { bg: '#dcfce7', border: '#86efac', color: '#198754' },
  changes_requested: { bg: '#fff1f3', border: '#f6c7d0', color: '#b42318' },
  archived: { bg: '#f3f4f6', border: '#d1d5db', color: '#4b5563' },
} as const

type ArticleStatusChipProps = {
  state: ArticleState
}

export function ArticleStatusChip({ state }: ArticleStatusChipProps) {
  const styles = STATUS_STYLES[state] || { bg: '#f3f4f6', border: '#d1d5db', color: '#374151' }

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        px: '10px',
        py: '4px',
        borderRadius: '999px',
        background: styles.bg,
        border: `1px solid ${styles.border}`,
        color: styles.color,
        fontWeight: 700,
        fontSize: '0.75rem',
        textTransform: 'capitalize',
        lineHeight: 1.5,
      }}
    >
      {state === 'changes_requested' ? 'Changes Requested' : state}
    </Box>
  )
}
